import { render, staticRenderFns } from "./PreviewRecording.vue?vue&type=template&id=01749236"
import script from "./PreviewRecording.vue?vue&type=script&lang=js"
export * from "./PreviewRecording.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01749236')) {
      api.createRecord('01749236', component.options)
    } else {
      api.reload('01749236', component.options)
    }
    module.hot.accept("./PreviewRecording.vue?vue&type=template&id=01749236", function () {
      api.rerender('01749236', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/PreviewRecording.vue"
export default component.exports